import Grid from '@material-ui/core/Grid'
import React, { useEffect, useState } from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

import { Error, Subtitle } from '../../../../../../components'
import { options } from '../../../../../../utils'
import { intentService } from '../../../../../../services'

import Option from './Option'

const { updateOpt, questionsFor, optComplete } = options

const useStyles = makeStyles(() => ({
  marginTop: { marginTop: '11px' },
  error: { marginBottom: '16px' },
}))

const Options = ({
  degrees,
  errors,
  exceptOfferIds,
  intent,
  loading,
  validating,
  setLoading,
  update,
  zipcode,
  weakStreetId,
  optRefs,
  degreeOpened,
  setDegreeOpened,
}) => {
  const classes = useStyles()

  const { optOne, optTwo, optThree } = intent

  const [questions, setQuestions] = useState([])

  const _optComplete = optComplete(questions)
  const _questionsFor = questionsFor(questions)
  const _updateOpt = updateOpt(update, questions)

  const toggleDegree = opt => open => () => setDegreeOpened(open ? opt : '')

  const tryToGetQuestions = async () => {
    setLoading(true)

    const {
      success,
      payload: { questions: _questions },
    } = await intentService.getSchoolsQuestions()

    if (success) {
      setQuestions(_questions)
    }

    setLoading(false)
  }

  useEffect(() => {
    tryToGetQuestions()
  }, [])

  const renderErrors = () => {
    const messages = Object.keys(errors || {})
      .filter(key => key === 'intents' || key.startsWith('intents.'))
      .flatMap(key => errors[key])

    if (messages.length) {
      return (
        <Grid item xs={12} className={classes.error}>
          <Error>
            <strong>Uma ou mais opções contém erros:</strong>
            <br />
            <span>{[...new Set(messages)].join(', ')}</span>
          </Error>
        </Grid>
      )
    }

    return <></>
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} className={classes.marginTop}>
        <Subtitle>
          Escolha até três opções de escolas que são de interesse do candidato.
          Todos os campos devem ser preenchidos.
        </Subtitle>
      </Grid>

      {renderErrors()}

      <Option
        degrees={degrees}
        errors={errors}
        validating={validating}
        label="Primeira (obrigatória)"
        loading={loading}
        option={optOne}
        prevOptIsCompleted={true}
        questions={_questionsFor({ optOne })}
        setLoading={setLoading}
        update={_updateOpt({ optOne })}
        zipcode={zipcode}
        weakStreetId={weakStreetId}
        degreeOpened={degreeOpened === 'one'}
        toggleDegree={toggleDegree('one')}
        questionsScope="one"
      />

      <Option
        divider
        degrees={degrees}
        errors={errors}
        exceptOfferIds={optOne.offerId || ''}
        validating={validating}
        label="Segunda (opcional)"
        loading={loading}
        option={optTwo}
        prevOptIsCompleted={_optComplete({ optOne })}
        questions={_questionsFor({ optTwo })}
        setLoading={setLoading}
        update={_updateOpt({ optTwo })}
        zipcode={zipcode}
        weakStreetId={weakStreetId}
        optRef={optRefs.optTwo}
        degreeOpened={degreeOpened === 'two'}
        toggleDegree={toggleDegree('two')}
        questionsScope="two"
      />

      <Option
        divider
        degrees={degrees}
        errors={errors}
        exceptOfferIds={exceptOfferIds}
        validating={validating}
        label="Terceira (opcional)"
        loading={loading}
        option={optThree}
        prevOptIsCompleted={
          _optComplete({ optOne }) && _optComplete({ optTwo })
        }
        questions={_questionsFor({ optThree })}
        setLoading={setLoading}
        update={_updateOpt({ optThree })}
        zipcode={zipcode}
        weakStreetId={weakStreetId}
        optRef={optRefs.optThree}
        degreeOpened={degreeOpened === 'three'}
        toggleDegree={toggleDegree('three')}
        questionsScope="three"
      />
    </Grid>
  )
}

export default Options
